import { DescriptionRow, SkillBlock, SkillRow, StyledSection } from './styles';

import { Col, Row } from 'react-styled-flexboxgrid';
import PostContent from '@/components/Blog/PostContent';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import SectionHeadline from '@/components/ui/elements/SectionHeadline';
import { imageUrlBuilder } from '@/utils/helpers';

const ServicesSection = ({ heading, description, backgroundImage, skills = [] }) => {
  const imgUrl = backgroundImage
    ? imageUrlBuilder.image(backgroundImage.image.asset).maxWidth(2048).auto('format').quality(80).url()
    : '';
  return (
    <article>
      <StyledSection bgImage={imgUrl} minHeight="275px">
        {null}
      </StyledSection>

      <StyledSection bgColor="white" minHeight="1vh">
        <ResponsiveGrid>
          <Row>
            <Col xs={12}>
              <header>
                <SectionHeadline>{heading}</SectionHeadline>
              </header>
            </Col>
          </Row>
          <DescriptionRow>
            <Col xs={12} md={6}>
              <PostContent content={description} />
            </Col>
          </DescriptionRow>

          <SkillRow>
            {skills.map((skillList) => (
              <Col key={skillList.heading} xs={12} sm={6}>
                <SkillBlock>
                  <h3>{skillList.heading}</h3>
                  <PostContent content={skillList.description} />
                </SkillBlock>
              </Col>
            ))}
          </SkillRow>
        </ResponsiveGrid>
      </StyledSection>
    </article>
  );
};

export default ServicesSection;
